<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <fieldset>
          <legend>
            {{ pageVocabs + "legend" | translate }}
          </legend>

          <div class="row">
            <!-- typeBank -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <enum-select-search
                class="tw-w-full"
                enumName="TypeBanks"
                label="common.bank"
                [control]="form?.get('typeBank')"
                [(value)]="model.typeBank"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- owner -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.owner"
                [control]="form?.get('owner')"
                label="common.owner"
                [maxLength]="50"
              >
              </form-field>
            </div>

            <!-- branch -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.branch"
                [control]="form?.get('branch')"
                [label]="fields + 'branch' | translate"
                [maxLength]="16"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <!-- accountNo -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.accountNo"
                [control]="form?.get('accountNo')"
                [label]="fields + 'accountNo' | translate"
                type="tel"
                [maxLength]="18"
              >
              </form-field>
            </div>

            <!-- cardNo -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.cardNo"
                [control]="form?.get('cardNo')"
                [label]="fields + 'cardNo' | translate"
                type="tel"
                [minLength]="16"
                [maxLength]="16"
              >
              </form-field>
            </div>

            <!-- position: relative;
            bottom: 23px;
            left: 23px; -->

            <!-- iban -->
            <div class="md:tw-w-2/3 xl:tw-w-1/2">
              <form-field
                class="tw-w-full"
                [label]="fields + 'iban'"
                [maxLength]="24"
                [control]="form?.get('iban')"
                [(value)]="iban"
                type="tel"
                classList="tw-text-lg dir-ltr"
                [isOnlyNumber]="true"
                [minLength]="24"
              >
                <span suffix-content class="tw-text-[15px]">IR</span>
              </form-field>
            </div>

            <!-- isActive -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-pt-5">
              <mat-slide-toggle
                formControlName="isActive"
                [(ngModel)]="model.isActive"
              >
                {{ "common.active" | translate }}</mat-slide-toggle
              >
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
